export default __webpack_public_path__ + "static/media/checkmark.81878e37.svg";